module.exports = __webpack_public_path__ + "img/farm64_ua.67150cd3.webp";